import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { QueryClient, QueryClientProvider, keepPreviousData } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime';
import { antdTheme } from './theme/tokens';
import './theme/global.css';
import { App } from './App';

dayjs.locale('zh-cn');
dayjs.extend(relativeTime);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // IM6：429 不重试(避免火上浇油，靠下个 refetchInterval 自然恢复)；其余维持原 retry:1。
      retry: (failureCount: number, error: any) => {
        if (error?.status === 429) return false;
        return failureCount < 1;
      },
      retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 30_000),
      // IM6：429/refetch 失败时保留上一次数据，列表(IM 会话/未读角标等)不闪空。v5 语法=函数引用、非布尔。
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={antdTheme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
